module.exports = __webpack_public_path__ + "static/media/companydefault.38b1bd41.jpg";